export const filter = {
	name: 'filter',
	title: 'Filter',
	content:
		'<path d="M 23.2,2.054c0.027-0.414-0.287-0.771-0.7-0.798c-0.016-0.001-0.032-0.002-0.048-0.002H1.5 c-0.414,0-0.75,0.336-0.75,0.75c0,0.017,0.001,0.033,0.002,0.05c0.361,5.033,4.028,9.21,8.972,10.22v9.875 c0,0.414,0.336,0.75,0.75,0.75c0.175,0,0.345-0.062,0.48-0.174l3-2.5c0.171-0.142,0.27-0.353,0.27-0.576v-7.375 C19.169,11.266,22.838,7.088,23.2,2.054z" stroke="currentColor" fill="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
